import api from "./core";

const basePath = "api/core/Transaction";

export default {
  get(id, extraHeaders = null) {
    return api.get(`${basePath}/${id}`, extraHeaders);
  },
  query(filter, extraHeaders = null) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  delete(id, extraHeaders = null) {
    return api.delete(`${basePath}/${id}`, extraHeaders);
  },
  update(id, data, extraHeaders = null) {
    return api.patch(`${basePath}/${id}`, data, extraHeaders);
  },
  create(data) {
    return api.post(`${basePath}/makePayment`, data);
  }
};
